import { __extends } from "tslib";
import { PutEventStreamRequest, PutEventStreamResponse } from "../models/index";
import { deserializeAws_restJson1PutEventStreamCommand, serializeAws_restJson1PutEventStreamCommand, } from "../protocols/Aws_restJson1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var PutEventStreamCommand = /** @class */ (function (_super) {
    __extends(PutEventStreamCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function PutEventStreamCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    PutEventStreamCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var handlerExecutionContext = {
            logger: logger,
            inputFilterSensitiveLog: PutEventStreamRequest.filterSensitiveLog,
            outputFilterSensitiveLog: PutEventStreamResponse.filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    PutEventStreamCommand.prototype.serialize = function (input, context) {
        return serializeAws_restJson1PutEventStreamCommand(input, context);
    };
    PutEventStreamCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restJson1PutEventStreamCommand(output, context);
    };
    return PutEventStreamCommand;
}($Command));
export { PutEventStreamCommand };
//# sourceMappingURL=PutEventStreamCommand.js.map